<template>
  <div class="comment-field-container">
    <div
      class="reply-to"
      v-if="
        messageReply !== null && messageReply.eventMessageId == eventMessage.id
      "
    >
      <p>
        <b>Replying to {{ messageReply.createdBy.firstName }}</b>
      </p>
      <p class="cancel" @click="cancelReply()">Cancel</p>
    </div>
    <UserProfileAvatar
      :profileImageUrl="this.userInfo.sessionInfo.profileImageUrl"
      :backgroundColor="avatarBackgroundColor"
      :initials="
        this.userInfo.firstName.charAt(0) + this.userInfo.lastName.charAt(0)
      "
    />
    <div class="comment-box">
      <p
        :ref="eventMessage.id + 'commentbox'"
        :placeholder="
          showPlaceholder
            ? messageReply
              ? 'Write a reply'
              : 'Write a comment'
            : ''
        "
        class="editor"
        :id="eventMessage.id + 'commentfield'"
        @blur="commentValidation()"
        @input="updateComment($event)"
        @keydown.enter.prevent
        contenteditable="true"
      ></p>
    </div>
    <span @click="sendMessage()" class="send-icon">
      <Send :enabled="comment.length >= 2" />
    </span>
  </div>
</template>

<script>
import Send from '@/assets/icons/Send'
import UserProfileAvatar from '@/components/UIElements/UserProfileAvatar'
export default {
  name: 'CommentField',
  props: [
    'placeholder',
    'eventMessage',
    'messageReply',
    'messageReplyId',
    'avatarBackgroundColor',
  ],
  components: { Send, UserProfileAvatar },
  data() {
    return {
      showPlaceholder: true,
      comment: '',
      placeHolderOverride: null,
    }
  },
  watch: {
    messageReplyId: function (newVal, oldVal) {
      if (newVal !== null) {
        this.$nextTick(() => {
          this.placeHolderOverride = `Reply to ${this.messageReply.createdBy.firstName}`

          if (newVal === this.messageReply.id) {
            document
              .getElementById(this.messageReply.eventMessageId + 'commentfield')
              .focus()
          }
        })
      }
    },
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  methods: {
    cancelReply() {
      this.resetCommentField()
      this.$emit('cancelReply')
    },
    sendMessage() {
      if (this.comment.length >= 2) {
        if (this.messageReplyId !== null) {
          this.$emit('sendNestedMessage', this.comment)
        } else {
          this.$emit('sendMessage', this.comment)
        }
        this.resetCommentField()
        this.$emit('cancelReply')
      }
    },
    updateComment(element) {
      this.showPlaceholder = false
      this.$nextTick(() => {
        this.comment = element.target.innerText
      })
    },
    resetCommentField() {
      this.comment = ''
      this.$refs[this.eventMessage.id + 'commentbox'].innerText = this.comment
      this.showPlaceholder = true
    },
    commentValidation() {
      if (this.comment === '') {
        this.showPlaceholder = true
      }
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';
.user-profile-avatar,
.user-profile-image {
  margin-right: 10px;
}
.comment-field-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .reply-to {
    margin-left: 42px;
    width: 100%;
    display: flex;
    margin-bottom: 12px;

    p {
      font-size: 0.725rem;
      color: $strom;
    }

    .cancel {
      color: $twilight;
      margin-left: 7px;
      cursor: pointer;
    }
  }
  .send-icon {
    margin-left: 10px;
    margin-top: 2px;
    cursor: pointer;
  }

  .comment-box {
    border: 1px solid $sleet;
    border-radius: 16px;
    background: white;
    width: auto;
    max-width: calc(100% - 42px - 42px);
    padding: 7px 12px 7px 12px;
    flex-grow: 1;
    position: relative;

    .editor {
      width: 100%;
      cursor: text;
      &:focus {
        outline: none;
      }

      &:empty::before {
        color: $strom;
        content: attr(placeholder);
      }
    }
  }
}
@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 992px) {
}
</style>
